function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "011---International-Payment",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m20.98 33h-14.98c-3.3137085 0-6-2.6862915-6-6v-21c0-3.3137085 2.6862915-6 6-6h38c3.3137085 0 6 2.6862915 6 6v17.52z",
  fill: "#e64c3c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m15 7v2h-6v-4h4c1.1032019.0032948 1.9967052.89679813 2 2z",
  fill: "#f0c419"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m9 5v4h-4v-2c.0032948-1.10320187.89679813-1.9967052 2-2z",
  fill: "#f29c1f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m9 9v4h-2c-1.10320187-.0032948-1.9967052-.8967981-2-2v-2z",
  fill: "#f0c419"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m15 9v2c-.0032948 1.1032019-.8967981 1.9967052-2 2h-4v-4z",
  fill: "#f29c1f"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#ecf0f1"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m13 22h-6c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h6c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m23 22h-6c-.5522847 0-1-.4477153-1-1s.4477153-1 1-1h6c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m9 28h-2c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h2c.55228475 0 1 .4477153 1 1s-.44771525 1-1 1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m16 28h-2c-.5522847 0-1-.4477153-1-1s.4477153-1 1-1h2c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z"
})), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 42,
  cy: 9,
  fill: "#f0c419",
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 36,
  cy: 9,
  fill: "#ecf0f1",
  r: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m58 39c0 .33-.01.67-.02 1-.123626 2.4247773-.7180101 4.8023137-1.75 7-.3182309.6883909-.6789258 1.3563444-1.08 2-2.6724427 4.3256426-6.9712594 7.3957112-11.93 8.52-2.7769336.6400146-5.6630664.6400146-8.44 0-4.9587406-1.1242888-9.2575573-4.1943574-11.93-8.52-.4010742-.6436556-.7617691-1.3116091-1.08-2-1.0319899-2.1976863-1.626374-4.5752227-1.75-7-.01-.33-.02-.67-.02-1s.01-.67.02-1c.123626-2.4247773.7180101-4.8023137 1.75-7 .3182309-.6883909.6789258-1.3563444 1.08-2 2.6724427-4.3256426 6.9712594-7.3957112 11.93-8.52 2.7769336-.6400146 5.6630664-.6400146 8.44 0 4.9587406 1.1242888 9.2575573 4.1943574 11.93 8.52.4010742.6436556.7617691 1.3116091 1.08 2 1.0319899 2.1976863 1.626374 4.5752227 1.75 7 .01.33.02.67.02 1z",
  fill: "#2fa8cc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m57.98 40c.01-.33.02-.67.02-1s-.01-.67-.02-1h-8.01c-.0484018-2.35647-.3365537-4.7018926-.86-7h7.12c-.3182309-.6883909-.6789258-1.3563444-1.08-2h-6.59c-1.19-3.84-3.07-6.85-5.34-8.52-2.7769336-.6400146-5.6630664-.6400146-8.44 0-2.27 1.67-4.15 4.68-5.34 8.52h-6.59c-.4010742.6436556-.7617691 1.3116091-1.08 2h7.12c-.5234463 2.2981074-.8115982 4.64353-.86 7h-8.01c-.01.33-.02.67-.02 1s.01.67.02 1h8.01c.0484018 2.35647.3365537 4.7018926.86 7h-7.12c.3182309.6883909.6789258 1.3563444 1.08 2h6.59c1.19 3.84 3.07 6.85 5.34 8.52 2.7769336.6400146 5.6630664.6400146 8.44 0 2.27-1.67 4.15-4.68 5.34-8.52h6.59c.4010742-.6436556.7617691-1.3116091 1.08-2h-7.12c.5234463-2.2981074.8115982-4.64353.86-7zm-19.98 16.88c-2.64-.62-4.98-3.62-6.43-7.88h6.43zm0-9.88h-7.02c-.5748989-2.2909561-.8935195-4.6386871-.95-7h7.97zm0-9h-7.97c.0564805-2.3613129.3751011-4.7090439.95-7h7.02zm0-9h-6.43c1.45-4.26 3.79-7.26 6.43-7.88zm2-7.88c2.64.62 4.98 3.62 6.43 7.88h-6.43zm0 35.76v-7.88h6.43c-1.45 4.26-3.79 7.26-6.43 7.88zm7.02-9.88h-7.02v-7h7.97c-.0564805 2.3613129-.3751011 4.7090439-.95 7zm-7.02-9v-7h7.02c.5748989 2.2909561.8935195 4.6386871.95 7z",
  fill: "#2980ba"
})));

var SvgStripe = function SvgStripe(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 58 58",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStripe, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stripe.54bb4c2c.svg";
export { ForwardRef as ReactComponent };